import apolloClient from 'apollo-client'
import {
  CREATE_TERMINAL,
  GET_TERMINAL,
  GET_TERMINAL_LIST,
  GET_USER_STRIPE_TERMINAL,
  UPDATE_TERMINAL,
} from './graphql'

class TerminalService {
  async getList() {
    const {data} = await apolloClient.query({
      query: GET_TERMINAL_LIST,
    })
    return {
      data: data.terminals.nodes,
      totalCount: data.terminals.totalCount,
    }
  }

  async getTerminal(id: string) {
    const {data} = await apolloClient.query({
      query: GET_TERMINAL,
      variables: {id},
    })
    const {__typename, ...terminal} = data.terminal
    return terminal
  }

  async save(terminal: any) {
    if (terminal.id) {
      return this.update(terminal)
    }
    return this.create(terminal)
  }

  async create({id, ...terminal}: any) {
    return await apolloClient.mutate({
      mutation: CREATE_TERMINAL,
      variables: {terminal},
    })
  }

  async update(terminal: any) {
    return await apolloClient.mutate({
      mutation: UPDATE_TERMINAL,
      variables: {terminal, id: terminal.id},
    })
  }

  async getUserStripeTerminal(locationId: string) {
    const {data} = await apolloClient.query({
      query: GET_USER_STRIPE_TERMINAL,
      variables: {locationId},
    })
    const {
      terminalReaders: {nodes},
    } = data
    if (nodes.length) {
      return nodes[0]
    }
  }
}
const terminalService = new TerminalService()
export default terminalService
